import { render } from "./RegisterSuccessView.vue?vue&type=template&id=541a8c97"
import script from "./RegisterSuccessView.vue?vue&type=script&lang=js"
export * from "./RegisterSuccessView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__